import { ToastProvider } from "@/ds";

import { useFinanceiroConfiguracoes } from "./use-financeiro-configuracoes";
import { FinanceiroConfiguracoesView } from "./view-financeiro-configuracoes";

function FinanceiroConfiguracoesScreenLigada() {
  const vm = useFinanceiroConfiguracoes();

  return <FinanceiroConfiguracoesView {...vm} />;
}

export function FinanceiroConfiguracoesScreen() {
  return (
    <ToastProvider position="top-right">
      <FinanceiroConfiguracoesScreenLigada />
    </ToastProvider>
  );
}

export type * from "./types-financeiro-configuracoes";
